import { useCallback, useContext, useMemo } from 'react'

import { QuizLearnerIdentityType } from 'app/types'
import { QuizIdentityContext } from 'providers'

export const useQuizIdentity = (orgId: string) => {
    const { getIdentity, isDismissed, identify, dismiss } = useContext(QuizIdentityContext)

    const identity = useMemo(() => getIdentity(orgId), [getIdentity, orgId])

    const identifyForOrg = useCallback(
        (nextIdentity: QuizLearnerIdentityType) => identify(orgId, nextIdentity),
        [identify, orgId],
    )

    return { identity, isDismissed, identify: identifyForOrg, dismiss }
}
